import { Box, Button, Grid, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import DrawerComponent from "../../components/Drawer";
import CardComponent from "../../components/Card";
import lottie from 'lottie-web';
import { defineElement } from '@lordicon/element';
import crmservices from "../../wsclient";
import { replaceParamTranslation } from "../../utils/util";
import { getOnboardingCards } from "../../enums/onboarding";

defineElement(lottie.loadAnimation);

export default function LearnView(props){
    const { t } = useTranslation();
    const { isOpen, showProcessing, appConfig } = props;
    const { palette } = useTheme();
    const session = crmservices.getSession() ;
    const orgName = session ? session.current_organisation_name : '';
    
    const handleOnClick = (item) => {
        props.setOpenSlides(true);
        props.setSelectedItem(item);
    };

    const onBoardingSlides = getOnboardingCards(appConfig).filter(item => item.showInLearn);
    const total = onBoardingSlides.length;
    const itemsPerRowXl = 3;
    const itemsPerRowXs = 2;

    const fullRowsXl = Math.floor(total / itemsPerRowXl); 
    const fullRowsXs = Math.floor(total / itemsPerRowXs);

    const lastRowStartXl = fullRowsXl * itemsPerRowXl;
    const itemsInLastRowXl = total - lastRowStartXl;

    const lastRowStartXs = fullRowsXs * itemsPerRowXs;
    const itemsInLastRowXs = total - lastRowStartXs;


    return (
        <>
            <DrawerComponent isOpen={isOpen} onClose={props.onClose} title={t("learn")} showProcessing={showProcessing} headerPosition='relative' width='100%'>
               
                <Box sx={{ padding: 2, backgroundColor: palette.mode === 'dark' ? '#383434' : palette.background.paper }}>
                    <Grid container spacing={2}>
                    {onBoardingSlides.map((item, index) => {
                        const isMobile = window.innerWidth < 768;
                        let desc = null;
                        let xl; let xs; let showFull = false;

                        if(isMobile){
                            desc = replaceParamTranslation(t(item.description), [orgName])
                            desc = desc.substring(0, 50) + '...';
                            const isInLastRowXs = index >= lastRowStartXs;
                            if (!isInLastRowXs || itemsInLastRowXs === itemsPerRowXs) 
                            {
                                xs = 6; 
                            } else {
                                xs = 12 / itemsInLastRowXs;
                            }
                            if(isInLastRowXs &&  (itemsInLastRowXs != itemsPerRowXs)){
                                showFull = true
                            } 
                        }
                        else{
                            desc = replaceParamTranslation(t(item.description), [orgName])
                            const isInLastRowXl = index >= lastRowStartXl;
                            if (!isInLastRowXl || itemsInLastRowXl === itemsPerRowXl) {
                                xl = 4; 
                            } else {
                                xl = 12 / itemsInLastRowXl;
                            }
                            if(isInLastRowXl &&  (itemsInLastRowXl != itemsPerRowXl))
                            {
                                showFull = true
                            } 
                        }


                        return (
                            <Grid item xs={xs} xl={xl} key={index} sx={{ display: 'flex' }}>
                            <CardComponent
                                noBorder={true}
                                bg={palette.mode === 'dark' ? '#383434' : palette.background.paper}
                                sx={{ flexGrow: 1, width: '100%' }}
                                width="100%"
                            >
                                <Box
                                    py={1.5}
                                    px={2}
                                    borderRadius="15px"
                                    border={`1px solid ${palette.border.main}`}
                                    onClick={() => handleOnClick(item)}
                                    sx={{ cursor: 'pointer', height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}
                                >
                                    {showFull ? 
                                        <>
                                            <Typography variant="h6">{replaceParamTranslation(t(item.title), [orgName])}</Typography>
                                            <Stack direction="row" justifyContent="space-around" alignItems="center" sx={{ height: '100%'}}>
                                                <Stack>
                                                    <Typography variant="subtitle1" color={palette.text.secondary} sx={{ mt: 1, mb: 2, lineHeight:1.3 }}>{desc}</Typography>
                                                    <Button sx={{width:'fit-content', lineHeight:1}} color="primary" variant="outlined" id="topupWallet/Submit">{t('learn_more')}</Button>
                                                </Stack>
                                                <div style={{ marginLeft: 8 }}>
                                                    <lord-icon
                                                        src={item.animationLink}
                                                        trigger="loop"
                                                        delay="1000"
                                                        stroke="bold"
                                                        colors={`primary:${palette.primary.main},secondary:${palette.secondary.main}`}
                                                        style={{width:'80px',  height:'80px'}}
                                                        >
                                                    </lord-icon>
                                                </div>

                                            </Stack>
                                        </>
                                    : 
                                        <>
                                            <Stack spacing={1} sx={{ height: '100%', justifyContent: 'space-around', alignItems: 'center' }}>
                                                <div style={{ alignSelf: 'center' }}>
                                                    <lord-icon
                                                        src={item.animationLink}
                                                        trigger="loop"
                                                        delay="1000"
                                                        stroke="bold"
                                                        colors={`primary:${palette.primary.main},secondary:${palette.secondary.main}`}
                                                        style={{width:'80px',  height:'80px'}}
                                                        >
                                                    </lord-icon>
                                                </div>
                                                <Typography variant="h6" sx={{textAlign: 'center'}}>{replaceParamTranslation(t(item.title), [orgName])}</Typography>
                                                <Typography variant="subtitle1" color={palette.text.secondary} sx={{textAlign: 'center', mt: 1, mb:2, lineHeight:1.3}}>{desc}</Typography>
                                                <Button sx={{width:'fit-content', lineHeight:1}} color="primary" variant="outlined" id="topupWallet/Submit">{t('learn_more')}</Button>
                                            </Stack>
                                        </>
                                    }
                                </Box>
                            </CardComponent>
                            </Grid>
                        );
                        })}
                    </Grid>
                </Box>

              
            </DrawerComponent>

        </>
    )
}